import { saveLocal } from '../util/local-storage';

let redirect: string;

export let envStr: string = process.env.REACT_APP_ENV
  ? (process.env.REACT_APP_ENV as string)
  : 'dev';

envStr = envStr.trim();

export const isDevMode = envStr === 'dev';

export const isLocal = envStr === 'local';

switch (envStr) {
  case 'local':
    redirect = 'https://localhost:3000/';
    break;
  case 'dev':
    redirect = 'https://miperfilsat.dev.rappi.com/';
    break;
  default:
    redirect = 'https://miperfilsat.rappi.com.mx/';
}

export type EnvironmentKeys = 'local' | 'dev' | 'mx';

export const environmentsCnsGateway: Record<
  EnvironmentKeys,
  {
    microServices: { api: string };
    timeZone: string;
    iso: string;
    redirect: string;
  }
> = {
  local: {
    microServices: {
      api: 'https://microservices.dev.rappi.com/api/cns-gateway-ms'
    },
    timeZone: 'America/Bogota',
    iso: 'co',
    redirect
  },
  dev: {
    microServices: {
      api: 'https://microservices.dev.rappi.com/api/cns-gateway-ms'
    },
    timeZone: 'America/Bogota',
    iso: 'co',
    redirect
  },
  mx: {
    microServices: {
      api: 'https://services.mxgrability.rappi.com/api/cns-gateway-ms'
    },
    timeZone: 'America/Mexico_City',
    iso: 'mx',
    redirect
  }
};

export const environmentsDispersion = {
  local: {
    microServices: {
      api: 'https://microservices.dev.rappi.com/api/dispersion-calculator'
    },
    timeZone: 'America/Bogota',
    iso: 'co',
    redirect
  },
  dev: {
    microServices: {
      api: 'https://microservices.dev.rappi.com/api/dispersion-calculator'
    },
    timeZone: 'America/Bogota',
    iso: 'co',
    redirect
  },
  mx: {
    microServices: {
      api: 'https://services.mxgrability.rappi.com/api/dispersion-calculator'
    },
    timeZone: 'America/Mexico_City',
    iso: 'mx',
    redirect
  }
};

export const getCountry = (): string => {
  return (isDevMode || isLocal ? 'local' : envStr) as EnvironmentKeys;
};

export const getRealCountry = (): string => {
  return (isDevMode ? 'dev' : envStr) as EnvironmentKeys;
};

export const getIso = (): string | undefined => {
  // @ts-ignore
  const country: EnvironmentKeys = getCountry() || getRealCountry();
  return (
    environmentsCnsGateway[country]?.iso || environmentsDispersion[country]?.iso
  );
};

export const getTimeZone = (): string => {
  return (
    environmentsCnsGateway[
      (getCountry() as EnvironmentKeys) || (getRealCountry() as EnvironmentKeys)
    ].timeZone ||
    environmentsDispersion[
      (getCountry() as EnvironmentKeys) || (getRealCountry() as EnvironmentKeys)
    ].timeZone
  );
};

export const setCountry = (country: string): void => {
  saveLocal('current_country', country, 0);
};

export default environmentsCnsGateway[(envStr as EnvironmentKeys) || 'local'] ||
  environmentsDispersion[(envStr as EnvironmentKeys) || 'local'];
